import React, { useState, useContext, useEffect } from "react";
import { useTranslation } from "react-i18next";
import MyContext from "../../../contexts/MyContext";
import { FormWrapper } from "../FormWrapper";
import { MyTextField } from "../../../components/my-text-field/MyTextField";
import { MyTimePicker } from "../../../components/my-time-picker/MyTimePicker";
import { MyDropdown } from "../../../components/my-dropdown/MyDropdown";
import { MyDatePicker } from "../../../components/my-date-picker/MyDatePicker";
import { Box, Button, TextField, IconButton, Grid } from "@mui/material";
import { AddFoodReceiptDialog } from "../dialogs/AddFoodReceiptDialog";
import { AddTransportReceiptDialog } from "../dialogs/AddTransportReceiptDialog";
import { AddAccommodationReceiptDialog } from "../dialogs/AddAccommodationReceiptDialog";
import { Add } from "@mui/icons-material";
import Autocomplete from "@mui/material/Autocomplete";
import { DepartureTimeExp, MinDate, TicketType, TransportationType, ValidTextRegExp } from "../../../Constant";
import { getSingleTicketTypeOption, getTrainStationOptions, getOtherTicketTypeOption } from "../../../Utils";
import TicketApiService from "../../../adapters/xhr/TicketApiService";
import { SingleTicketFormatRegExp, MovingoTicketRules, MaximumLengthOfOtherTicketValue } from "../../../Constant";
import { Delete } from "@mui/icons-material";

export const TicketForm1 = (props) => {
  const { t, i18n } = useTranslation();
  const myContext = useContext(MyContext);
  const [biljettnummerValueErr, setBiljettnummerValueErr] = useState("");

  const [addFoodReceipt, setAddFoodReceipt] = useState(false);
  const [addAccommodationReceipt, setAddAccommodationReceipt] = useState(false);
  const [addTransportReceipt, setAddTransportReceipt] = useState(false);
  const [departureStationValueErr, setDepartureStationValueErr] = useState("");
  const [departureDateValueErr, setDepartureDateValueErr] = useState("");
  const [departureTimeValueErr, setDepartureTimeValueErr] = useState(null);
  const [arrivalStationValueErr, setArrivalStationValueErr] = useState("");
  const [otherTicketTypeValueErr, setOtherTicketTypeValueErr] = useState("");

  const trainStationOptions = getTrainStationOptions(myContext.trainStations);

  const singleTicketTypeOption = getSingleTicketTypeOption();
  const otherTicketTypeOption = getOtherTicketTypeOption();

  const [ticketType, setTicketType] = React.useState(singleTicketTypeOption);

  const [periodTickets, setPeriodTickets] = useState(null);

  const today = new Date();
  const minDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() - MinDate, 0, 0, 0);

  useEffect(() => {
    if (periodTickets === null) fetchTickets();
  }, [periodTickets]);

  useEffect(() => {
    if (myContext.ticketType === TicketType.SINGLE) setTicketType(singleTicketTypeOption);
  }, [myContext.ticketType]);

  const fetchTickets = async () => {
    let response = await TicketApiService.getTicketsForPublic();
    if (response?.isSuccess) {
      let data = response.data.map((option, key) => {
        let rObj = {};
        rObj["id"] = option.id;
        rObj["title"] = option.title;
        rObj["ticketType"] = TicketType.COMMUTER;
        return rObj;
      });
      setPeriodTickets(data);
    } else {
      setPeriodTickets([]);
    }
  };

  const handleChangeDepartureTime = (value) => {
    let departureTimeReg = new RegExp(DepartureTimeExp);
    if (departureTimeReg.test(value)) {
      myContext.changeDepartureTime(value);
    } else myContext.changeDepartureTime(null);
  };

  const validateTicketNumber = () => {
    let ticketValue = myContext.biljettnummerValue;
    if (ticketType.ticketType === TicketType.SINGLE) {
      const result = new RegExp(SingleTicketFormatRegExp).test(ticketValue);
      if (!result) {
        setBiljettnummerValueErr("invalid_single_ticket_format");
        return false;
      }
    }
    if (ticketType.ticketType === TicketType.COMMUTER) {
      if (ticketValue.length < MovingoTicketRules.MinLength) {
        setBiljettnummerValueErr("invalid_movingo_ticket_format");
        return false;
      }
    }
    setBiljettnummerValueErr("");
    return true;
  };

  const validate = async () => {
    let isValid = true;
    if (!myContext.validateTicketNumber) {
      setBiljettnummerValueErr("");
    } else if (ticketType.ticketType !== TicketType.OTHER && !myContext.biljettnummerValue.trim()) {
      isValid = false;
      setBiljettnummerValueErr("ticketnumber_must_be_entered");
    } else {
      isValid = validateTicketNumber();
    }

    if (ticketType.ticketType === TicketType.OTHER && !myContext.otherTicketTypeValue) {
      setOtherTicketTypeValueErr("ticket_type_must_be_specified");
      isValid = false;
    } else {
      setOtherTicketTypeValueErr("");
    }

    if (!myContext.departureStation) {
      setDepartureStationValueErr("departure_station_must_be_specified");
      isValid = false;
    } else {
      setDepartureStationValueErr("");
    }
    if (!myContext.arrivalStation) {
      setArrivalStationValueErr("arrival_station_must_be_specified");
      isValid = false;
    } else {
      setArrivalStationValueErr("");
    }
    if (!myContext.departureDate || myContext.departureDate.trim() === "") {
      setDepartureDateValueErr("departure_date_must_be_specified");
      isValid = false;
    } else if (!validateDepartureDate()) {
      isValid = false;
    } else {
      setDepartureDateValueErr("");
    }

    if (!myContext.departureTime) {
      setDepartureTimeValueErr("departure_time_must_be_specified");
      isValid = false;
    } else {
      setDepartureTimeValueErr("");
    }
    if (isValid) myContext.changeActiveSlide((myContext.activeSlide += 1));
  };

  const removeFoodReceipt = () => {
    myContext.changeFoodReceipt([]);
    myContext.changeFoodTotalCost("");
  };

  const removeTransportReceipt = () => {
    myContext.changeTransportReceipt([]);
    myContext.changeTransportTotalCost("");
    myContext.changeFromAddress("");
    myContext.changeToAddress("");
    myContext.changeNumberOfKmDriven("");
  };

  const removeAccommodationReceipt = () => {
    myContext.changeAccommodationReceipt([]);
    myContext.changeAccommodationTotalCost("");
  };

  const validateDepartureDate = () => {
    let date = myContext.departureDate;
    if (date != null) {
      let time = new Date(date).getTime();
      let minTime = new Date(minDate).getTime();
      let maxTime = new Date(today).getTime();
      myContext.changeDepartureDate(date);
      if (time >= minTime && time <= maxTime) {
        setDepartureDateValueErr("");
        return true;
      } else {
        setDepartureDateValueErr("register_dates_up_to_min_days_older_than_today_date");
        return false;
      }
    }
  };

  useEffect(() => {
    validateDepartureDate();
  }, [myContext.departureDate]);

  return (
    <MyContext.Consumer>
      {(context) => (
        <React.Fragment>
          <FormWrapper onContinue={validate} hasBackButton={false} number={`1/2`} heading={`${t("ticket_info")}`}>
            <Autocomplete
              style={{ width: "100%", margin: "1rem 0", ...props.style }}
              options={[singleTicketTypeOption].concat(periodTickets).concat([otherTicketTypeOption])}
              getOptionLabel={(option) => t(option.title)}
              value={ticketType}
              onChange={(e, value) => {
                context.changeTicketType(value.ticketType);
                if (value.ticketType == TicketType.COMMUTER) {
                  context.changeTicketId(value.id);
                } else {
                  setBiljettnummerValueErr("");
                  context.changeTicketId(null);
                }
                setTicketType(value);
              }}
              disableClearable={true}
              renderInput={(params) => <TextField {...params} label={t("ticket_type")} variant="outlined" />}
            />
            {ticketType.ticketType == TicketType.OTHER && (
              <MyTextField
                helperText={t(otherTicketTypeValueErr)}
                autoComplete="on"
                regExp={ValidTextRegExp}
                value={context.otherTicketTypeValue}
                label={t("state_which_ticket_type")}
                required={true}
                onChange={context.changeOtherTicketTypeValue}
                maxLength={MaximumLengthOfOtherTicketValue}
                onKeyPress={(e) => {
                  if (e.key === "Enter") {
                    validate();
                  }
                }}
              />
            )}
            <MyTextField
              helperText={t(biljettnummerValueErr)}
              autoComplete="on"
              regExp={ValidTextRegExp}
              maxLength={14}
              value={context.biljettnummerValue}
              label={t("ticket_number")}
              required={ticketType.ticketType !== TicketType.OTHER}
              onChange={context.changeBiljettnummerValue}
              onKeyPress={(e) => {
                if (e.key === "Enter") {
                  validate();
                }
              }}
            />
            <MyDropdown
              required={true}
              helperText={t(departureStationValueErr)}
              onChange={(e, value) => context.changeDepartureStation(value)}
              label={t("departure_station")}
              value={context.departureStation}
              options={trainStationOptions.filter((option) => option.key !== context.arrivalStation?.key)}
            />
            <MyDropdown
              required={true}
              helperText={t(arrivalStationValueErr)}
              onChange={(e, value) => context.changeArrivalStation(value)}
              label={t("arrival_station")}
              value={context.arrivalStation}
              options={trainStationOptions.filter((option) => option.key !== context.departureStation?.key)}
            />
            <MyDatePicker
              required={true}
              error={departureDateValueErr !== ""}
              label={t("departure_date")}
              value={context.departureDate}
              onAccept={(date) => context.changeDepartureDate(date?.toString())}
              helperText={t(departureDateValueErr)}
              maxDate={today}
              minDate={minDate}
              placeholder={t("date_format")}
              cancelLabel={t("cancel")}
              okLabel={t("ok")}
              locale={i18n.language}
              views={["day"]}
            />
            {context.departureTimeOptions == null || context.departureTimeOptions.length == 0 ? (
              <MyTimePicker
                required={true}
                onAccept={(date) => context.changeDepartureTime(date?.toString())}
                value={context.departureTime}
                label={t("departure_time")}
                helperText={t(departureTimeValueErr)}
              />
            ) : (
              <MyDropdown
                required={true}
                helperText={t(departureTimeValueErr)}
                onChange={(e, time) => handleChangeDepartureTime(time !== null ? time.value : null)}
                label={t("departure_time")}
                freeSolo={true}
                placeholder={`HH:mm`}
                onFreeSolo={(e) => handleChangeDepartureTime(e.target.value)}
                value={context.departureTime}
                options={context.departureTimeOptions}
              />
            )}
            <h2 style={{ fontSize: "1.25rem", width: "100%", marginBottom: "0.5rem" }}>{t("do_you_have_additional_costs")}</h2>
            <hr className="margin top-0 bottom-0" aria-hidden={true} style={{ width: "100%" }} />
            {!context.distance?.isShortTrain && !context.fullTicketRefund && (
              <>
                <Grid container>
                  <Grid item xs={context.foodTotalCost ? 11 : 12} style={{ display: "flex" }}>
                    <Button
                      aria-expanded={addFoodReceipt}
                      aria-haspopup="dialog"
                      variant="text"
                      className="button secondary w-100"
                      style={{
                        textTransform: "unset",
                      }}
                      onClick={(e) => setAddFoodReceipt(true)}
                      startIcon={<Add />}
                    >
                      <span>{t("add_food_expenses")}</span>
                      <div style={{ marginLeft: "auto", display: "flex", alignItems: "center" }}>
                        <Box component="span" color="primary.main">
                          {context.foodTotalCost && `${context.foodTotalCost} ${t("kr")}`}
                        </Box>
                      </div>
                    </Button>
                  </Grid>
                  {context.foodTotalCost && (
                    <Grid item xs={1}>
                      <IconButton aria-label={t("delete")} onClick={(e) => removeFoodReceipt()}>
                        <Delete />
                      </IconButton>
                    </Grid>
                  )}
                </Grid>
                <hr className="margin top-0 bottom-0" aria-hidden={true} style={{ width: "100%" }} />
              </>
            )}
            <Grid container>
              <Grid item xs={context.transportTotalCost || context.numberOfKmDriven ? 11 : 12} style={{ display: "flex" }}>
                <Button
                  aria-expanded={addTransportReceipt}
                  aria-haspopup="dialog"
                  variant="text"
                  className="button secondary w-100"
                  style={{
                    textTransform: "unset",
                  }}
                  onClick={(e) => setAddTransportReceipt(true)}
                  startIcon={<Add />}
                >
                  <span>{t("add_transport_expenses")}</span>
                  <div style={{ marginLeft: "auto", display: "flex", alignItems: "center" }}>
                    <Box component="span" color="primary.main">
                      {context.transportationType == TransportationType.OTHERS && context.transportTotalCost && `${context.transportTotalCost} ${t("kr")}`}
                      {context.transportationType == TransportationType.USEOWNCAR && context.numberOfKmDriven && `${context.numberOfKmDriven} ${t("km")}`}
                    </Box>
                  </div>
                </Button>
              </Grid>
              {(context.transportTotalCost || context.numberOfKmDriven) && (
                <Grid item xs={1}>
                  <IconButton aria-label={t("delete")} onClick={(e) => removeTransportReceipt()}>
                    <Delete />
                  </IconButton>
                </Grid>
              )}
            </Grid>
            {!context.distance?.isShortTrain && !context.fullTicketRefund && (
              <>
                <hr className="margin top-0 bottom-0" aria-hidden={true} style={{ width: "100%" }} />
                <Grid container>
                  <Grid item xs={context.accommodationTotalCost ? 11 : 12} style={{ display: "flex" }}>
                    <Button
                      aria-expanded={addAccommodationReceipt}
                      aria-haspopup="dialog"
                      variant="text"
                      className="button secondary w-100"
                      style={{
                        textTransform: "unset",
                      }}
                      onClick={(e) => setAddAccommodationReceipt(true)}
                      startIcon={<Add />}
                    >
                      <span>{t("add_accommodation_expenses")}</span>
                      <div style={{ marginLeft: "auto", display: "flex", alignItems: "center" }}>
                        <Box component="span" color="primary.main">
                          {context.accommodationTotalCost && `${context.accommodationTotalCost} ${t("kr")}`}
                        </Box>
                      </div>
                    </Button>
                  </Grid>
                  {context.accommodationTotalCost && (
                    <Grid item xs={1}>
                      <IconButton aria-label={t("delete")} onClick={(e) => removeAccommodationReceipt()}>
                        <Delete />
                      </IconButton>
                    </Grid>
                  )}
                </Grid>
                <hr className="margin top-0 bottom-0" aria-hidden={true} style={{ width: "100%" }} />
              </>
            )}
            <hr className="margin top-0 bottom-0" aria-hidden={true} style={{ width: "100%" }} />
            {((context.transportationType === TransportationType.OTHERS && context.transportReceipt.length > 0) ||
              context.foodReceipt.length > 0 ||
              context.accommodationReceipt.length > 0 ||
              (context.transportationType === TransportationType.USEOWNCAR && context.numberOfKmDriven)) && (
              <MyTextField
                maxLength={500}
                regExp={ValidTextRegExp}
                value={context.otherComments}
                onChange={context.changeOtherComments}
                label={t("other_comments")}
                multiline={true}
                rows={4}
                style={{ marginBottom: "0" }}
              />
            )}
          </FormWrapper>
          {addFoodReceipt && <AddFoodReceiptDialog open={addFoodReceipt} onClose={(e) => setAddFoodReceipt(false)} />}
          {addTransportReceipt && <AddTransportReceiptDialog open={addTransportReceipt} onClose={(e) => setAddTransportReceipt(false)} />}
          {addAccommodationReceipt && <AddAccommodationReceiptDialog open={addAccommodationReceipt} onClose={(e) => setAddAccommodationReceipt(false)} />}
        </React.Fragment>
      )}
    </MyContext.Consumer>
  );
};
